import { autorun } from "mobx";
import React from "react";
import imageProcesserSize from "src/constant/imageProcesserSize";
import FTImageStore from "src/store/FTImageStore";
import "./FTDownloadSize.scss"
import utils from "src/utils";
import { useCurrentEffect, useUploadImage } from "src/hooks";
import clsx from "clsx";

interface Iprops {
  theme: "dark" | "light"
}
export default function FTDownloadSize(props: Iprops) {
  let { theme } = props
  let [smallSize, setSmallSize] = React.useState<any>({})
  let [largerSize, setLargerSize] = React.useState<any>({})
  let [ needHD, setNeedHD] = React.useState(false)
  let currentImage = useUploadImage()
  React.useEffect(() => {
    autorun(() => {
      let { currentSize, acturalSize, imageHD } = FTImageStore
      let smallScale = utils.aspectFitScale(currentSize.width, currentSize.height, imageProcesserSize.IMAGE_SIDE_VALUE)
      let largerScale = utils.aspectFitScale(acturalSize.width, acturalSize.height, Number(imageProcesserSize.SUPPER_RESOLUTION_HIGH_ID))
      setSmallSize({
        width: Math.round(currentSize.width * smallScale),
        height: Math.round(currentSize.height * smallScale)
      })
      setLargerSize({
        width: Math.round(acturalSize.width * largerScale),
        height: Math.round(acturalSize.height * largerScale)
      })
      setNeedHD(imageHD)
    })
  }, [])
  if(!currentImage) return <></>

  return <div className={clsx("download_size", theme && theme)}>
    {needHD ? `${largerSize.width}x${largerSize.height} px` : `${smallSize.width}x${smallSize.height} px` }
  </div>
}